var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKompetenz(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "13.6mm",
    height: "9.079mm",
    viewBox: "0 0 13.6 9.079",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath830"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m732.74 398.46h38.55v25.736h-38.55z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-82.837 -104.51)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.35278 0 0 -.35278 -175.66 254.16)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath830)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m771.09 423.75c-0.1666 0.2017-0.4119 0.3185-0.6732 0.3204l-16.382 0.1194h-7e-3c-0.2362 0-0.4576-0.0917-0.6242-0.259-0.1674-0.1681-0.2581-0.3911-0.2556-0.6284 0.0106-0.9685-0.0308-2.3867-0.25-4.0554l8.5468-0.0945c0.3604-4e-3 0.6989-0.1656 0.9289-0.4435 0.2283-0.2761 0.3229-0.6361 0.2598-0.9876-2.4594-13.703-11.626-18.166-19.957-19.267 11.429 0.2388 24.966 4.9216 28.6 24.577 0.0473 0.2556-0.0209 0.5176-0.1868 0.7186",
    fill: "#a1c74a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m755.66 415.03-10.706 0.1522c-4e-3 2e-4 -9e-3 2e-4 -0.0128 2e-4 -0.4788 0-0.8721-0.387-0.8798-0.8685-0.0249-1.5774-0.2936-4.6604-1.8125-7.5857-1.8414-3.5461-4.9201-5.8233-9.1507-6.7686-0.2834-0.0634-0.3739-0.2869-0.364-0.4749 0.01-0.1871 0.1224-0.399 0.4093-0.4323 6.4168-0.7453 17.931 0.2589 22.946 15.369 0.0472 0.1421 0.0246 0.2934-0.062 0.4152-0.0858 0.1206-0.2198 0.191-0.3675 0.1931",
    fill: "#175583"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m761.78 418.23c-0.0872 0.1051-0.2151 0.1664-0.3514 0.1679l-13.442 0.1484h-5e-3c-0.1239 0-0.2401-0.0482-0.3274-0.1362-0.0877-0.0883-0.1348-0.2053-0.1324-0.3295 0.01-0.5473 0-1.2918-0.0707-2.1693l8.2198-0.1169c0.3931-6e-3 0.7489-0.1925 0.9765-0.513 0.2285-0.3212 0.2883-0.7206 0.1641-1.0953-2.9028-8.7454-7.9183-12.919-12.938-14.764 7.7022 1.368 15.756 5.9204 18.003 18.439 0.0237 0.1329-0.0109 0.2638-0.0975 0.3687",
    fill: "#70bde5"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKompetenz);
export default __webpack_public_path__ + "static/media/kompetenz.2f32921257d9750fc62e5c013451e584.svg";
export { ForwardRef as ReactComponent };